import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

type Return = 'noVoucherDiscount' | 'priceBelowMinCondition' | 'default';

export const usePriceLabelState = (): Return => {
  const voucherDiscount = useResolvedVoucherDiscount();
  const {
    currentVariant: { price },
  } = useProductDetailContext();

  if (!voucherDiscount) {
    return 'noVoucherDiscount';
  }

  const isPriceBelowMinCondition =
    isConditionalDiscount(voucherDiscount) &&
    voucherDiscount.discountConditions.some(
      (condition) => price.value < condition.conditionMin
    );

  //TODO: Change it when the data comes from the backend.
  if (isPriceBelowMinCondition && voucherDiscount.conditionType === 'Price') {
    return 'priceBelowMinCondition';
  }

  return 'default';
};
